export const formData = [
  {
    label: 'Our Understanding',
    type: 'textArea',
    name: 'ourUnderstanding',
    col: '2',
    flag: true,
    tooltip:
      "Insert a short paragraph with your project team's understanding of the deal (Sample: [Client] is looking to accelerate growth, establish greater market penetration, and improve the customer experience from the acquisition of [Target]. [Client] is seeking a strong integration advisor with deep IMO and functional capabilities to assist with the integration.)",
  },
  {
    label: 'Deal Type',
    type: 'text',
    className: 'mr3125',
    name: 'dealType',
    col: '2',
    linkName: 'dealTypeUrl',
    linkPlaceholder: 'Deal Type Source Link (URL)',
    tooltip:
      'Input the Deal Type to provide additional details of how the two companies will integrate (Example: Acquisition - Consolidation / Absorption)',
  },
  {
    label: 'Target Deal Close Date',
    type: 'text',
    className: 'mr3125',
    name: 'dealCloseDate',
    col: '2',
    tooltip:
      'Input target date for deal close (Example: 8/15/2021 or "End of calendar year 2021")',
    linkName: 'dealCloseDateUrl',
    linkPlaceholder: 'Target Deal Close Date Source Link (URL)',
  },
  {
    label: 'Transaction Value',
    type: 'text',
    className: 'mr3125',
    name: 'transactionValue',
    col: '2',
    linkName: 'transactionValueUrl',
    linkPlaceholder: 'Transaction Value Source Link (URL)',
    tooltip:
      'Input the reported transaction value of the deal (Example: $10.6 B)',
  },
  {
    label: 'Financing',
    type: 'text',
    className: 'mr3125',
    name: 'financing',
    col: '2',
    flag: true,
    linkName: 'financingUrl',
    linkPlaceholder: 'Financing Source Link (URL)',
    tooltip:
      'Input the details of how the deal will be financed (Example: $25.00 per share, all cash transaction)',
  },

  // {
  //   label: 'Link to Announcement Source(URL)',
  //   type: 'text',
  //   className: 'mr3125',
  //   name: 'linkToAnnounceSource',
  //   col: '1',
  //   showInEdit: true,
  // },

  {
    label: 'Deal Rationale',
    type: 'textArea',
    className: 'mr3125',
    name: 'dealRationale',
    col: '1',
    linkName: 'dealRationaleUrl',
    linkPlaceholder: 'Deal Rationale Source Link (URL)',
    tooltip:
      'Based on the company press releases, summarize the proposed deal rationale for why the Client / Target are entering into a deal agreement',
  },
  {
    label: 'Announcement',
    type: 'textArea',
    className: 'mr3125',
    name: 'revSynergies',
    col: '1',
    linkName: 'revSynergiesUrl',
    linkPlaceholder: 'Announcement Source Link (URL)',
    tooltip:
      'Leverage the announcement communication released by the companies to include the public announcement of the deal',
  },
  {
    label: 'Synergies',
    type: 'textArea',
    className: 'mr3125',
    name: 'costSynergies',
    col: '1',
    linkName: 'costSynergiesUrl',
    linkPlaceholder: 'Synergies Source Link (URL)',
    tooltip:
      'Review the deal announcement for any details on how the deal willl benefit the Client / Target (i.e., Revenue Synergies, Cost Synergies, new markets, etc.)',
  },

  // {
  //   label: 'Deal Terms',
  //   type: 'textArea',
  //   className: 'mr3125',
  //   name: 'dealTerms',
  //   col: '1',
  // },
  // {
  //   label: 'Termination Fee',
  //   type: 'text',
  //   className: 'mr3125',
  //   name: 'terminationFee',
  //   col: '2',
  // },
];

// export const data = {
//   id: 'F6998CD9-4429-4272-AD02-6760CFE78701',
//   projectId: '22D77741-1537-4D28-9206-0526224F2277',
//   dealType: 'type',
//   dealCloseDate: '2020-08-02',
//   transactionValue: 'value',
//   financing: '22D77741-1537-4D28-9206-0526224F2277',
//   revSynergies: '22D77741-1537-4D28-9206-0526224F2277',
//   costSynergies: '22D77741-1537-4D28-9206-0526224F2277',
//   dealRationale: '22D77741-1537-4D28-9206-0526224F2277',
//   dealTerms: '22D77741-1537-4D28-9206-0526224F2277',
//   terminationFee: '22D77741-1537-4D28-9206-0526224F2277',
// };
export const data = {
  costSynergies: '22D77741-1537-4D28-9206-0526224F2277',
  dealCloseDate: '2020-08-02',
  dealRationale:
    'Editable text field to write things about backoffice. Sed lorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Editable text field to write things about backoffice. Sed lorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing.',
  dealTerms:
    'Editable text field to write things about backoffice. Sed lorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Editable text field to write things about backoffice. Sed lorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing.',
  dealType: 'type',
  financing: '22D77741-1537-4D28-9206-0526224F2277',
  id: 'F6998CD9-4429-4272-AD02-6760CFE78701',
  projectId: '22D77741-1537-4D28-9206-0526224F2277',
  revSynergies:
    'Editable text field to write things about backoffice. Sed lorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. Vivamus enim diam, luctus et scelerisque vitae, congue sed purusLorem ipsum dolor sit amet, ipiscing elit. Sed ac diam elit. ',
  terminationFee: '22D77741-1537-4D28-9206-0526224F2277',
  transactionValue: 'value',
};
